export const findBoostITAccount = (accounts) => accounts.find(
    (loggedAccount) => loggedAccount.username.toLowerCase().includes('boost-it.pt')
)